/**
 * Describe your function here
 * @param { * } data - Function input
 * @return { * } - Function response
 */
const commonProviders = [
  'aol',
  'gmail',
  'hotmail',
  'yahoo',
  'bol',
];

//
const isValid = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const clean = (email) => {
  if (email) {
    let newEmail = email.replace(/\s/g, '');
    commonProviders.forEach(e => newEmail = newEmail.replace(`${e}com`, `${e}.com`));

    if (newEmail.indexOf('.') < 0 && newEmail.indexOf('@') < 0) {
      return null;
    }

    return newEmail;
  }
  return null;
};

export default async (entry) => {
  const newEmail = clean(entry);

  return {
    value: newEmail == '' ? null : newEmail,
    original: entry,
    valid: isValid(newEmail),
  };
};
